<template>
  <div class="mt-1">
    <b-card>
      <b-overlay :show="loading" rounded="sm" no-fade>
        <b-row class="mb-1">
          <b-col
            cols="12"
            md="7"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <b-button
              variant="outline-primary"
              class="btn-icon"
              :to="{ path: '/settings' }"
            >
              <i class="fa-solid fa-arrow-left"></i>
              <span class="ml-25">Back</span>
            </b-button>
            <h3 class="ml-1">Courses</h3>
          </b-col>

          <b-col cols="12" md="5">
            <div class="d-flex align-items-center justify-content-end">
              <div class="d-flex align-items-center mr-1">
                <label>Show</label>
                <v-select
                  v-model="perPage"
                  :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
                />
                <label>entries </label>
              </div>

              <b-form-input
                v-model="filter"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
              <b-button variant="primary" @click="addCourse()">
                <span class="text-nowrap">Add Course</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

        <b-table
          sticky-header
          striped
          hover
          bordered
          ref="refCourseListTable"
          :outlined="true"
          :fields="fields"
          :items="filteredCourses"
          responsive="sm"
          :small="true"
          class="table table-sm table-responsive"
          :filter="filter"
          @filtered="onFiltered"
          :filter-included-fields="filterOn"
          show-empty
          empty-text="No matching records found"
          :current-page="currentPage"
          :per-page="perPage"
          @row-clicked="editCourse($event.id)"
        >
          <template #cell(title)="data">
            <div style="font-size: 1rem; max-width: 400px;" class="p-25">
              <p class="mb-0 font-weight-600">{{ data.value }}</p>
              <small
                class="text-muted text-truncate d-block"
                v-if="data.item.summary"
                :title="data.item.summary"
                >{{ data.item.summary }}</small
              >
            </div>
          </template>

          <!-- <template #cell(trainer)="{ item }">
            <span>{{ item.trainer && item.trainer.name ? item.trainer.name : '-' }}</span>
          </template>

          <template #cell(venue)="{ item }">
            <span>{{ item.venue && item.venue.name ? item.venue.name : '-' }}</span>
          </template> -->

          <template #cell(is_active)="{ item }">
            <b-badge
              :variant="item.is_active ? 'light-success' : 'light-secondary'"
            >
              {{ item.is_active ? "Active" : "Inactive" }}
            </b-badge>
          </template>

          <template #cell(actions)="{ item }">
            <div class="d-flex align-items-center justify-content-center">
              <b-button
                variant="warning"
                class="mr-1 p-50"
                @click.stop="editCourse(item.id)"
              >
                <i class="fa-solid fa-pen-to-square mr-25"></i>
                <span> Edit</span>
              </b-button>
              <b-button
                variant="danger"
                class="p-50"
                @click.stop="deleteCourse(item.id)"
              >
                <span>Delete</span>
              </b-button>
            </div>
          </template>
        </b-table>

        <div class="mx-2 mb-1 mt-1">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >Showing {{ dataMeta.from }} to {{ dataMeta.to }} of
                {{ dataMeta.of }} entries</span
              >
            </b-col>

            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
import {
  BOverlay,
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BBadge,
  BPagination,
} from "bootstrap-vue";
import store from "@/store";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { onUnmounted } from "@vue/composition-api";
import settingsStoreModule from "../settingsStoreModule";
import vSelect from "vue-select";

export default {
  components: {
    BOverlay,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BBadge,
    BPagination,
    vSelect,
    ToastificationContent,
  },
  setup() {
    const MODULE = "settings";
    if (!store.hasModule(MODULE))
      store.registerModule(MODULE, settingsStoreModule);
    onUnmounted(() => {
      if (store.hasModule(MODULE)) store.unregisterModule(MODULE);
    });
  },
  data() {
    return {
      courses: [],
      filter: null,
      filterOn: ["title", "application_method"],
      loading: false,
      currentPage: 1,
      perPageOptions: [10, 25, 50, 100],
      perPage: Number(localStorage.getItem("coursesShow") || 50),
      totalRows: 0,
      fields: [
        {
          key: "title",
          label: "Course",
          sortable: true,
          thStyle: "color:white!important",
        },
        // { key: 'trainer', label: 'Trainer', sortable: false, thStyle: 'color:white!important' },
        // { key: 'venue', label: 'Venue', sortable: false, thStyle: 'color:white!important' },

        {
          key: "is_active",
          label: "Status",
          sortable: true,
          class: "text-center",
          thStyle: "color:white!important",
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          class: "text-center",
          thStyle: "color:white!important",
        },
      ],
    };
  },
  created() {
    this.getCourses();
  },
  computed: {
    dataMeta() {
      return {
        from:
          this.totalRows !== 0 ? this.perPage * (this.currentPage - 1) + 1 : 0,
        to:
          this.perPage * (this.currentPage - 1) + Number(this.perPage) <
          this.totalRows
            ? this.perPage * (this.currentPage - 1) + Number(this.perPage)
            : this.totalRows,
        of: this.totalRows,
      };
    },
    filteredCourses() {
      if (!this.filter) return this.courses;
      const term = this.filter.toLowerCase();
      return this.courses.filter(
        (item) =>
          (item.title && item.title.toLowerCase().includes(term)) ||
          // (item.trainer && item.trainer.name && item.trainer.name.toLowerCase().includes(term)) ||
          // (item.venue && item.venue.name && item.venue.name.toLowerCase().includes(term)) ||
          (item.default_application_method &&
            item.default_application_method.toLowerCase().includes(term))
      );
    },
  },
  watch: {
    perPage(val) {
      localStorage.setItem("coursesShow", val);
    },
  },
  methods: {
    getCourses() {
      this.loading = true;
      store
        .dispatch("settings/fetchCourses", { per_page: 500 })
        .then((res) => {
          // normalize trainer/venue if backend later adds relations
          this.courses = (res.data.data || res.data || []).map((c) => ({
            ...c,
            //   trainer: c.trainer || c.trainer_id ? { id: c.trainer_id, name: c.trainer_name || c.trainer?.name } : c.trainer,
            //   venue: c.venue || c.venue_id ? { id: c.venue_id, name: c.venue_name || c.venue?.name } : c.venue,
          }));
          this.totalRows = this.courses.length;
          this.loading = false;
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Error loading courses",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          this.loading = false;
        });
    },
    addCourse() {
      this.$router.push({ name: "settings-course-add" });
    },
    editCourse(id) {
      this.$router.push({ name: "settings-course-edit", params: { id } });
    },
    deleteCourse(id) {
      this.$bvModal
        .msgBoxConfirm("Are you sure you want to delete this course?", {
          size: "sm",
          title: "Confirm",
          okVariant: "primary",
          okTitle: "Yes",
          cancelTitle: "No",
          cancelVariant: "outline-secondary",
          centered: true,
        })
        .then((val) => {
          if (!val) return;
          this.loading = true;
          store
            .dispatch("settings/deleteCourseById", { id })
            .then(() => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Deleted",
                  icon: "ThumbsUpIcon",
                  variant: "success",
                },
              });
              this.getCourses();
            })
            .catch(() => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Delete failed",
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });
              this.loading = false;
            });
        });
    },
    onFiltered(items) {
      this.totalRows = items.length;
      this.currentPage = 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
.table-responsive.b-table-sticky-header {
  max-height: 75vh !important;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
